import { useMemo } from 'react';
import moment from 'moment-timezone';
import { get, isEmpty } from 'lodash';
import { buildTimeseriesQuery, formatQueryStatus } from './utils';
import { getDimensionData } from '@api/dimensionContainer';
import instance from '@api/axiosInstance';
import useQueryParams from '@src/components/widget-panel/hooks/useQueryParams';
import { DURATION_BUCKET_COLOR, arddDimension, arddMetric } from '../constants';
import { getStackedTimeSeries } from '../utils';
import useWidgetQuery from '@src/components/widget-panel/hooks/useWidgetQuery';
import { useSelector } from 'react-redux';

const dimension = arddDimension;
const metric = arddMetric;

const orderBuckets = Object.keys(DURATION_BUCKET_COLOR).reverse();

function useDurationTimeseries({ wid, enabled = true }) {
  const { interval, filter: globalFilter, _rKey, liveMode } = useQueryParams();

  const query: any = useMemo(() => {
    const filter = [...globalFilter];
    const q = buildTimeseriesQuery({
      metrics: [metric, dimension],
      filter,
      interval: `${moment(interval.from).format()}/${moment(interval.to).format()}`,
      granularity: interval.granularity,
    }) as any;
    q.options.stacked = { metric: dimension };
    return q;
  }, [dimension, globalFilter, interval, metric]);

  const { data, ...queryStatus } = useWidgetQuery({
    wid,
    queryKey: ['widget', 'network-duration-ts', query],
    queryFn: () => {
      return getDimensionData({ queries: [query] }, {}, instance).then((response) => {
        return get(response, ['data', 0, 'data'], []);
      });
    },
    options: {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled && !liveMode,
      staleTime: 5 * 60 * 1000, // 5m
    },
  });

  const chartData = useMemo(() => {
    if (isEmpty(data)) {
      return undefined;
    }
    return getStackedTimeSeries({
      data,
      series: orderBuckets,
      colorMap: DURATION_BUCKET_COLOR,
      groupBy: dimension,
      metric,
      interval,
    });
  }, [data, interval, status]);

  return {
    ...formatQueryStatus({ ...queryStatus, isEmpty: isEmpty(data) }),
    data: chartData,
  };
}

export default useDurationTimeseries;
